export default __webpack_public_path__ + "static/media/avatar.d1877ebe.svg";